function uniqueValuesInArray(array) {
  return array.filter((value, index, self) => self.indexOf(value) === index);
}

function sortAlphabetically(a, b) {
  return a > b ? 1 : -1;
}

function sortByDate(a, b) {
  return new Date(a) - new Date(b);
}

function sortByDateDesc(a, b) {
  return new Date(b) - new Date(a);
}

function toSentence(array) {
  const wordsConnector = ', ';
  const twoWordsConnector = ' and ';
  const lastWordConnector = ', and ';

  let sentence;

  switch (array.length) {
    case 0:
      sentence = '';
      break;
    case 1:
      [sentence] = array;
      break;
    case 2:
      sentence = array[0] + twoWordsConnector + array[1];
      break;
    default:
      sentence =
        array.slice(0, -1).join(wordsConnector) +
        lastWordConnector +
        array[array.length - 1];
      break;
  }

  return sentence;
}

export {
  uniqueValuesInArray,
  sortAlphabetically,
  sortByDate,
  sortByDateDesc,
  toSentence,
};
